const generateRandomPortalId = () => {
  return Math.floor(10000000 + Math.random() * 90000000).toString();
};
export const PRODUCTION_PQL_FORM_ATTRIBUTES = {
  formId: '5ae29a72-cc99-4702-9bcc-936891469830',
  portalId: '53'
};
export const QA_PQL_FORM_ATTRIBUTES = {
  formId: '479b8d6d-b9b2-4941-b16a-74d2cef76778',
  // uncomment to see form submissions succeed, without this the EmailModal
  // will not submit and the CommModal opening PQL submission will fail.
  // portalId: '99609805',
  portalId: generateRandomPortalId()
};